/**
 * Manages loading of custom theme CSS files.
 * Built-in themes (modern, fantasy, scifi) are bundled by Vite and need no
 * dynamic loading. Custom themes listed in content/config.json with a `cssFile`
 * are injected via a <link> element when selected so they can override or
 * supplement the built-in CSS.
 */

export function loadCustomThemeCss(id: string, list: ThemeDefinition[]): void {
  const theme = list.find((t) => t.id === id);
  const existing = document.getElementById('custom-theme-css') as HTMLLinkElement | null;

  if (!theme?.cssFile) {
    // Built-in theme — remove any previously injected custom stylesheet
    existing?.remove();
    return;
  }

  const href = `/${theme.cssFile}`;
  if (existing) {
    existing.href = href;
  } else {
    const link = document.createElement('link');
    link.id = 'custom-theme-css';
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }
}
